import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from 'shared/components/Dropdown/Dropdown'

// Component injects props from redux-form Field component.
// TODO: when migration from redux-form-5 is finished, refactor Dropdown component and remove this one.
const FormDropdown = ({input, meta, ...props}) =>
  <Dropdown {...input} {...meta} {...props} />

FormDropdown.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
}

export default FormDropdown
